import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=854bf3ae&scoped=true"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"
import style0 from "./stats.vue?vue&type=style&index=0&id=854bf3ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854bf3ae",
  null
  
)

export default component.exports